export default "__VITE_ASSET__uoeYqDVY__"